<script lang="ts">
/*
For Containing buttons. 
For either type= 
"radio" only one button can be selected at a time, 
"checkmark"- multiple buttons can be selected at a time

*/

/* Info for buttons- text, icon, bg color, text color, etc*/
export class ButtonInfo
{
    text="";
    icon="";
    type="";
    fontsize="16px";
    fontsize_icon="32px";
    callback=()=>{console.log("button clicked!")};
    extra_info={};//for sending extra info- like the id of the thing that got clicked
    
    color_bg="";
    color_bg2="";
    color_txt="";
    class="";/*Mainly for adding in the category class */

    /*For holding down for more options */
    hold_for_callback=false;
    callback_held=()=>{console.log("button held!")};
    constructor(obj:any)
    {
        Object.assign(this, obj);
        return this;
    }
}

import { defineComponent } from 'vue'
import Button from './Button.vue';
export default defineComponent({
    components: { Button },
    
    props: {
        type: { type: String, default: "radio" },
        button_info: { type: Array<ButtonInfo>, required: true },
        Changed:{ type:Function, default:()=>{console.log("EntryEl: Close not passed corrrectly!");}},
        default_selection: { type: Number, default: 0 },

    },
    data() {
        return {
        force_vue_update:0,
        button_selected:undefined,
        loaded:false,
        select_btn_times_waiting:0,//for checking if waiting for buttons to be loaded/ mounted, to max out after say 100 tries
        
        };
    },
    async mounted() 
    {
        //select the default button
        // let btn_clicked = (this.$refs.btn as Array<any>)[this.default_selection];
        // btn_clicked.ShowOutline();
        // this.button_selected= btn_clicked;
        console.log("Button Group, this button info: ", this.button_info)
    },
    //computed- so we can pass variables into css without having to do javascript
    //from: https://stackoverflow.com/questions/42872002/in-vue-js-component-how-to-use-props-in-css
    computed: 
    {
        cssProps() 
        {
        }
    },
    methods: 
    {
        /*
        For selecting a button, but not letting the parent know/ setting the button selected on init 
        */
        InitSelect()
        {
            // this.$nextTick(()=>{
                if(!this.button_selected)
                    this.SelectButton(this.default_selection);
            // });
        },
        SelectButton(index:number)
        {
            //might take awhile to mount, so should have it run whenever they are
            if(!this.$refs.btn)
            {
                this.$nextTick(()=>{
                    // this.SelectButtonCheckedIfLoaded(index);
                    if(this.select_btn_times_waiting<100)
                    {
                        // console.log("selecting button index: ", index, "which should be: ", this.button_info[index], this.button_info);
                        this.SelectButton(index);
                        this.select_btn_times_waiting++;
                    }
                    else
                        console.error("Problem, button reference never getting set, checked 100 ticks!!!", this.select_btn_times_waiting)
                });
            }
            else
                this.SelectButtonCheckedIfLoaded(index);
        },
        SelectButtonCheckedIfLoaded(index:number)
        {
            console.log("selecting button ", index);
            let btn_clicked = (this.$refs.btn as Array<any>)[index];
            if(this.button_selected)
                (this.button_selected as any).HideOutline();
            
            btn_clicked.ShowOutline();
            this.button_selected= btn_clicked;
        },
        ButtonClicked(btn:ButtonInfo, extra_info:any, index:number)
        {
            this.SelectButton(index);
            // console.log("Button group recieved click, from btn: ", btn, "extra info: ", extra_info, "btn: ", this.$refs.btn, "index: ", index );
            //need to add a class onto this button that was selected, so it looks highlighted
            // let btn_clicked = (this.$refs.btn as Array<any>)[index];

            //does work for setting the class of the button, but need to set the bg on there
            // this.button_info[index].class+= "selected_btn";
            // this.force_vue_update++;
            // let ele = btn_clicked.GetMainElement();
            // let bg = ele.querySelector(".bg");
            // bg.classList.add("selected_btn");

            // if(this.button_selected)
            //     (this.button_selected as any).HideOutline();

            // // console.log("btn clicked: ", btn_clicked, "btn_clicked. el: ", btn_clicked.GetMainElement())
            // btn_clicked.ShowOutline();
            // this.button_selected= btn_clicked;

            // let element = (this.$refs.btn as Array<any>)[0].$el;
            // console.log("element: ", element);
            // element.classList.add("selected_btn");

            //call back the parent with the button info
            this.Changed(btn);

        }
    },
    watch: 
    {
        button_info:function(button_info_in) 
        {
            console.log("YO: watch button_info_in start called", button_info_in);
            // this.PreviousEntriesIn();
            // this.CreatePrevAttributes();
            this.force_vue_update++;
        },
    },
    
});
</script>

<template>
    <!-- Using updated to allow this to select the button after the component has been rendered before -->
    <div :key="force_vue_update" @vue:updated="InitSelect" style="display: flex; gap:5px;">
        <Button v-for="btn, i in button_info"
        ref="btn"
        :text="btn.text"
        :icon="btn.icon"
        :type="btn.type"
        :fontsize="btn.fontsize"
        :fontsize_icon="btn.fontsize_icon"
        fontweight="regular"
        padding="10px 10px"
        margin="0px 0px"
        :wrap_txt="true"


        :callback="(extra_info:any)=>{ButtonClicked(btn, extra_info, i)}" 
        :extra_info="btn.extra_info" 

        :color_bg="btn.color_bg"
        :color_bg2="btn.color_bg2"
        :color_txt="btn.color_txt"
        :class="btn.class"

        :hold_for_callback="btn.hold_for_callback"
        :hold_callback="btn.callback_held"
        />
    </div>

</template>

<style scoped>

</style>